// extracted by mini-css-extract-plugin
export default {"section":"NoteExpertGeneralPageWorkMobile_section__ePj4J","content":"NoteExpertGeneralPageWorkMobile_content__vrUQ5","title":"NoteExpertGeneralPageWorkMobile_title__VwW20"};